import React, { useState } from 'react';
import { useUser } from 'store/User/Context';
import styled from 'styled-components';
import { userApiRequests } from 'utils/api-requests/user';
import { CheckOpinionParamsOpinionTypeEnum } from 'utils/types/UserSettingsModels';

import Button from 'components/atom/Button';
import TextInput from 'components/common/Inputs/TextInput';
import Modal from 'components/common/Modal/Modal';

const ChatbotOpinionContainer = styled.div`
    margin-left: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 0 15px;
    gap: 15px;

    @media (max-width: 1100px) {
        margin-left: 0px;
    }
`;
const Title = styled.h2`
`;

const ChatbotRatingWrapper = styled.div`
    display: flex;
    gap: 5px;
    flex-wrap: wrap;

    @media (max-width: 1100px) {
       max-width: 350px;
    }

    @media (max-width: 768px) {
       max-width: 200px;
    }
`;

const OpinionBox = styled.div<{ isSelected?: boolean }>`
    height: 30px;
    width: 30px;
    border-radius: 5px;
    border: 1px solid var(--color-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: ${(props) => props.isSelected ? 'var(--color-primary)' : 'transparent'};
    color: ${(props) => props.isSelected ? 'white' : 'var(--color-primary)'};
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
        background-color: var(--color-primary);
        color: var(--color-white);
    }
`;

const RatingDisplay = styled.h2`
    margin: 0;
    color: var(--color-primary);
`;

const TextInputWrapper = styled.div`
    width: 100%;
`;

const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const OpinionModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    padding: 40px;
    min-width: 400px;
`;

interface ChatbotOpinionProps {
    onOpinionSubmitted: () => Promise<void>;
}

const ChatbotOpinion: React.FC<ChatbotOpinionProps> = ({ onOpinionSubmitted }) => {
    const { user } = useUser();
    const [showOpinionPopup, setShowOpinionPopup] = useState(false);
    const [selectedRating, setSelectedRating] = useState<number | null>(null);
    const [opinionText, setOpinionText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleRatingClick = (rating: number) => {
        setSelectedRating(rating);
        setShowOpinionPopup(true);
    };

    const handleCloseModal = () => {
        setShowOpinionPopup(false);
        setSelectedRating(null);
        setOpinionText('');
    };

    const handleSubmitOpinion = async () => {
        if (!selectedRating || !opinionText.trim()) {
            return;
        }

        setIsSubmitting(true);

        await userApiRequests.sendOpinion({
            opinionType: CheckOpinionParamsOpinionTypeEnum.CHAT_BOT,
            opinionText: opinionText.trim(),
            rating: selectedRating
        });

        handleCloseModal();
        onOpinionSubmitted();
        setIsSubmitting(false);
    };

    const ratingOptions = Array.from({ length: 10 }, (_, i) => i + 1);

    return (
        <>
            <ChatbotOpinionContainer>
                <Title>Oceń flipchat</Title>
                <ChatbotRatingWrapper>
                    {ratingOptions.map((rating) => <OpinionBox
                        key={rating}
                        onClick={() => handleRatingClick(rating)}
                    >
                        {rating}
                    </OpinionBox>)}
                </ChatbotRatingWrapper>
            </ChatbotOpinionContainer>

            <Modal
                isOpen={showOpinionPopup}
                onClose={() => setShowOpinionPopup(false)}
                centeredContent
                backgroundColor={user.isDarkMode ? 'var(--color-alt-hover)' : '#fff'}
                strictContentHeight>
                <OpinionModalContainer>
                    <RatingDisplay>
                        Twoja ocena to {selectedRating}/10
                    </RatingDisplay>

                    <TextInputWrapper>
                        <TextInput
                            description
                            max={400}
                            maxLength={400}
                            placeholder="Co możemy poprawić?"
                            value={opinionText}
                            onChange={(e) => setOpinionText(e.target.value)}
                        />
                    </TextInputWrapper>

                    <ButtonWrapper>
                        <Button
                            onClick={handleSubmitOpinion}
                            disabled={isSubmitting || !opinionText.trim()}
                        >
                            {isSubmitting ? 'Wysyłanie...' : 'Dodaj ocenę'}
                        </Button>
                    </ButtonWrapper>
                </OpinionModalContainer>
            </Modal>
        </>

    );
};

export default ChatbotOpinion;
